import { Dialog } from './dialog'

export const initializeListingTeasers = (
  $root: HTMLElement = document.body
): void => {
  const $listingTeasers =
    [...$root.querySelectorAll('a.listing-teaser')] as HTMLAnchorElement[]
  for (const $teaser of $listingTeasers) {
    if (!$teaser.classList.contains('listing-teaser--dialog')) {
      $teaser.addEventListener('click', (event) => {
        event.preventDefault()

        const dialog = new Dialog()
        dialog.setContentUrl($teaser.href, true)
        dialog.setVisible(true)
      })

      $teaser.classList.add('listing-teaser--dialog')
    }
  }
}
